// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyActivateWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyActivateWebApiHandler_activate } from '@zg-rentals/ts-rental-manager-api-client';

import type { ListingAlias, UserPropertyActivateResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';

interface ActivateParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyActivateWebApiHandler_activate_Args {
  getParams: ActivateParams;
}

export type RentalManagerUserPropertyActivateWebApiHandler_activate_Options = UseMutationOptions<
  UserPropertyActivateResponseWebDto,
  unknown,
  RentalManagerUserPropertyActivateWebApiHandler_activate_Args
>;

/**
 * Activate a property
 */
export const useRentalManagerUserPropertyActivateWebApiHandler_activate = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyActivateWebApiHandler_activate_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyActivateWebApiHandler_activate_Args) =>
      RentalManagerUserPropertyActivateWebApiHandler_activate(args.getParams, httpClient),
  });
};
